"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { Dispatch, ReactNode, SetStateAction } from "react";

interface DrawerDialogProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  title: string;
  description?: string;
  children: ReactNode;
  classNameWindow: string;
  classNameTitle?: string;
  isDesktopForAllScreen?: boolean;
}

export function DrawerDialog({
  open,
  setOpen,
  title,
  description,
  children,
  classNameWindow,
  classNameTitle,
  isDesktopForAllScreen,
}: DrawerDialogProps) {
  const isDesktop = useMediaQuery("(min-width: 768px)");

  if (isDesktop || isDesktopForAllScreen) {
    return (
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className={`${classNameWindow}`}>
          <DialogHeader>
            <DialogTitle className={`${classNameTitle} text-md md:text-lg`}>
              {title}
            </DialogTitle>
            {description && (
              <DialogDescription>{description}</DialogDescription>
            )}
          </DialogHeader>
          <>{children}</>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerContent className={`${classNameWindow} flex flex-col px-5`}>
        <DrawerHeader>
          <DrawerTitle>{title}</DrawerTitle>
          {description && (
            <DrawerDescription className="text-sm">
              {description}
            </DrawerDescription>
          )}
        </DrawerHeader>
        <>{children}</>
      </DrawerContent>
      <DrawerClose />
    </Drawer>
  );
}
